export default __webpack_public_path__ + "assets/images/a9a920298cd499a33eb41f7a4e9285d9.jpg";